import React from 'react';
import LessonHome from '../LessonHome';

const Lesson10 = (props) => {

    return ( 
        <LessonHome
            {...props}
        />        
     );
}
 
export default Lesson10;